import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerDetailsService {
  baseUrl = environment.baseUrl;
  deviceStatus: any;
  constructor(private http: HttpClient) { }
 
  getCustomerInfo(customerID) {
    return this.http.get<any>(this.baseUrl + `/services/core/users/api/v1/customer/${customerID}`)
  }

  getPspPrinters(customerID) {
    return this.http.get<any>(this.baseUrl + `/services/core/users/api/v1/customers/${customerID}/psp_site_printers`)
  }

  getCustomerInkSubUsage(postData) {
    return this.http.post<any>(this.baseUrl + `/services/core/users/api/v1/substrate_and_ink_consumption?customer_id=${postData.customer}&from=${postData.from}&to=${postData.to}`, '');
  }

  updateCustomerInfo(customerID, postData) {
    return this.http.post<any>(this.baseUrl + `/services/core/users/api/v1/customers/${customerID}/update_customer_detail`, postData);
  }

  updateSites(customerID, postData) {
    return this.http.post<any>(this.baseUrl + `/services/core/users/api/v1/customers/${customerID}/update_sites`, postData);
  }

  getCustomerAlerts(customerID) {
    return this.http.get<any>(this.baseUrl + `/services/seals/api/v1/alerts/customer_proactive_alerts?customer_id=${customerID}`)
  }

  getCustomerDeviceStatus(customerID) {
    return this.http.get<any>(this.baseUrl + `/services/core/users/api/v1/customers/${customerID}/customer_device_status`)
  }

  storeDeviceStatus(deviceStatus) {
    this.deviceStatus = deviceStatus
  }

  getDeviceStatus(device) {
    let obj = this.deviceStatus?.find(o => o.device_id === device.device_id);
    if (obj == undefined)
      return '-'
    else
      return this.titleCaseWord(obj.device_status);
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  getStatusColor(device) {
    let obj = this.deviceStatus?.find(o => o.device_id === device.device_id);
    if (obj == undefined)
      return ''
    else {
      if(obj.device_status == "PRINTING")
        return "#337BBC"
      else if (obj.device_status == "DISCONNECTED")
        return "#ADADAD"
      else if (obj.device_status == "OPTIMIZING")
        return "#8332A4"
      else if (obj.device_status == "READY")
        return "#4D9838"
      else if (obj.device_status == "ERROR")
      return "#BE1313"
    }
  }

  getCustomerCoverageDetails(customerID) {
    return this.http.get<any>(this.baseUrl +`/services/core/users/api/v1/customers/${customerID}/printers_coverage_details`)
  }
}
